export default "__VITE_ASSET__BQ8n44Fu__"